import { FormizoSchema } from "Components/LabIZO/Formizo";
import { FormizoCustom, IFGColumn } from "Components/LabIZO/Formizo/FormizoSchema.interface";
import { store } from "static";
import _ from "lodash";
import { FollowingIntent, QuickReply } from "../schema";

import HtmlToolbar from "../HtmlToolbar";

/**
 * button caption qill be generated if not given uppon add, but will be later required during edit
 */
const ButtonCaptiionSchema = {
  add: (lang: { display: string; value: string }) => ({
    label: "Button Caption",
    name: `intent.${lang.value}.description`,
    format: "text",
  }),
  info: (lang: { display: string; value: string }) => ({
    label: "Button Caption",
    name: `intent.${lang.value}.description`,
    format: "text",
    validate: ["required"],
  }),
};

const FaqFormSchema = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any) => {
  return [
    {
      columns: [
        {
          page: [
            {
              header: "General",
            },
            {
              label: "ID",
              name: "name",
              validate: ["required"],
              format: "text",
              readOnly: true,
            },
            {
              label: "Created At",
              name: "CREATED_AT",
              format: "text",
              readOnly: true,
            },
            {
              label: "Last Modified",
              name: "LASTMODIFIED",
              format: "text",
              readOnly: true,
            },
            {
              label: "Alias",
              name: "alias",
              validate: ["required"],
              format: "text",
            },
            {
              label: "Description",
              name: "description",
              format: "text",
            },
          ],
        },
        {
          page: [
            {
              header: "Expired Answer",
            },
            {
              label: "Enable",
              name: "answer.expiriable.enable",
              format: "bool",
            },
            {
              label: "Enable From",
              name: "answer.expiriable.from",
              format: "date",
              dateType: "datetime",
              dateFormat: "YYYY-MM-DD HH:mm:ss",
            },
            {
              label: "Enable To",
              name: "answer.expiriable.to",
              format: "date",
              dateType: "datetime",
              dateFormat: "YYYY-MM-DD HH:mm:ss",
            },
          ],
        },
      ],
    },
    {
      columns: [QuestionColumn(formValue, addOns, fLang, buttonCapSchema), AnswerColumn(formValue, addOns, fLang, buttonCapSchema), QRColumn(formValue, addOns, fLang, buttonCapSchema)],
    },
  ];
};

const QuestionColumn = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any) => ({
  width: "48%",
  page: [
    {
      header: "Questions",
    },
    {
      tabs: store.sysInfo.Language.available.map((lang) => ({
        label: `${lang.display}`,
        error: (formValue: any, addOns: any, { formError }: any) => {
          let examplesErrors = _.get(formError, `intent.${lang.value}.examples`) || [];
          const captionError = _.get(formError, `intent.${lang.value}.description`) || [];
          const error = [...examplesErrors, ...captionError].filter((_e: any) => !_.isEmpty(_e));
          return error.length > 0;
        },
        page: () => {
          const defaultLang = store.sysInfo.Language.default;
          const minItems = defaultLang === lang.value ? 1 : 0;

          return [
            buttonCapSchema(lang),
            {
              label: `Examples (${lang.display})`,
              name: `intent.${lang.value}.examples`,
              canAdd: true,
              canDelete: true,
              minItems: minItems,
              array: [
                {
                  label: "",
                  name: "text",
                  format: "text",
                  validate: ["required"],
                },
              ],
            },
          ];
        },
      })),
    },
  ],
});

const AnswerColumn = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any): IFGColumn => ({
  width: "48%",
  page: [
    {
      header: "Answer",
    },
    {
      label: "Type",
      name: "answer.type",
      format: "select",
      selectStyle: "radio",
      selectDirection: "row",
      options: [
        { label: "Default", value: "static" },
        // { label: "Document", value: "document" },
        { label: "Expired", value: "pStatic" },
      ],
      defaultValue: "static",
    },
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "static",
      fold: FAQStaticAnswer(formValue, addOns, fLang, buttonCapSchema),
    },
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "document",
      fold: FAQDocumentAnswer(formValue, addOns, fLang, buttonCapSchema),
    },
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "pStatic",
      fold: FAQExpireAnswer(formValue, addOns, fLang, buttonCapSchema),
    },
  ],
});

const FAQStaticAnswer = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any): FormizoSchema[] => [
  {
    label: "Answer ID",
    name: "answer._id",
    format: "text",
    readOnly: true,
  },

  // ★ 主要語言（預設 EN）工具列
  { inject: <HtmlToolbar /> },

  {
    label: `${fLang.display}(${fLang.value})`,
    name: `answer.text.${fLang.value}.0`,
    format: "textarea",
    rows: 5,
    variant: "outlined",
    validate: ["required"],
    placeholder: "Enter answer here...",
  },

  {
    label: "Other Languages",
    foldStyle: "none",
    // ★ 為每個「其他語言」在 textarea 前也注入一條工具列
    collapse: store.sysInfo.Language.available
      .filter((o) => o.value !== fLang.value)
      .flatMap((o) => [
        { inject: <HtmlToolbar /> } as FormizoSchema,
        {
          label: `${o.display}`,
          name: `answer.text.${o.value}.0`,
          format: "textarea",
          rows: 5,
          variant: "outlined",
          placeholder: "Enter answer here...",
        } as FormizoSchema,
      ]),
  },
];

const FAQExpireAnswer = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any): FormizoSchema[] => [
  {
    label: "Answer ID",
    name: "answer._id",
    format: "text",
    readOnly: true,
  },

  // ★ 主要語言工具列
  { inject: <HtmlToolbar /> },

  {
    label: `${fLang.display}(${fLang.value})`,
    name: `answer.expiriable.text.${fLang.value}.0`,
    format: "textarea",
    rows: 5,
    variant: "outlined",
    placeholder: "Enter answer here...",
  },

  {
    label: "Other Languages",
    foldStyle: "none",
    collapse: store.sysInfo.Language.available
      .filter((o) => o.value !== fLang.value)
      .flatMap((o) => [
        { inject: <HtmlToolbar /> } as FormizoSchema,
        {
          label: `${o.display}`,
          name: `answer.expiriable.text.${o.value}.0`,
          format: "textarea",
          rows: 5,
          variant: "outlined",
          placeholder: "Enter answer here...",
        } as FormizoSchema,
      ]),
  },
];

const FAQDocumentAnswer = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any): FormizoSchema[] => [
  {
    label: "Documents",
    name: "answer.documents",
    format: "multiSelect",
    selectStyle: "autocomplete",
    selectRef: "documents",
    selectCap: "_id",
    selectVal: "_id",
  },
];

const QRColumn = (formValue: any, addOns: any, fLang: { display: string; value: string }, buttonCapSchema: any): IFGColumn => ({
  width: "48%",
  page: [
    {
      header: "Quick Reply",
    },
    //QuickReply,
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "static",
      fold: [QuickReply],
    },
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "document",
      fold: [QuickReply],
    },
    {
      label: "answer.type",
      control: "answer.type",
      controlFunc: (doc: any, field: any) => field === "pStatic",
      fold: ExpireAnswerQRB(),
    },
    {
      header: "Suggested Questions",
    },
    FollowingIntent,
  ],
});

const ExpireAnswerQRB = (): FormizoSchema[] => {
  let copy = JSON.parse(JSON.stringify(QuickReply));
  copy.name = "answer.expiriable.quickReplies";
  return [copy];
};

export const Info: FormizoCustom = (formValue, addOns, fLang: { display: string; value: string }) => {
  return FaqFormSchema(formValue, addOns, fLang, ButtonCaptiionSchema.info);
};
export const Add: FormizoCustom = (formValue, addOns, fLang: { display: string; value: string }) => {
  return FaqFormSchema(formValue, addOns, fLang, ButtonCaptiionSchema.add);
};

export const Edit = Info;
